import { ChevronLeft, ChevronRight } from "lucide-react";

import { Button } from "@/components/ui/button";

import { PRO014_STORES_TEXTS } from "../../../components/edit-campaign/constants";
import { Pro014StoresEditor } from "../../../components/edit-campaign/pro014-stores-editor";
import { PRO014_WIZARD_TEXTS } from "../../constants";

const PENDING_HINT_ID = "pro014-stores-pending-hint";

interface Pro014EditStoresStepProps {
  campaignCode: number;
  onBack: () => void;
  onNext: () => void;
}

interface StepNavigationProps {
  hasPendingChanges: boolean;
  onBack: () => void;
  onNext: () => void;
}

function StepNavigation({ hasPendingChanges, onBack, onNext }: StepNavigationProps): JSX.Element {
  const describedBy: string | undefined = hasPendingChanges ? PENDING_HINT_ID : undefined;

  return (
    <div className="space-y-2 pt-2">
      {hasPendingChanges && (
        <p id={PENDING_HINT_ID} role="status" className="text-sm text-amber-700 dark:text-amber-400">
          {PRO014_STORES_TEXTS.SAVE_BEFORE_LEAVING}
        </p>
      )}
      <div className="flex justify-between gap-2">
        <Button
          variant="outline"
          onClick={onBack}
          disabled={hasPendingChanges}
          aria-describedby={describedBy}
          className="w-full md:w-auto"
        >
          <ChevronLeft className="mr-2 h-4 w-4" aria-hidden />
          {PRO014_WIZARD_TEXTS.BACK}
        </Button>
        <Button
          onClick={onNext}
          disabled={hasPendingChanges}
          aria-describedby={describedBy}
          className="w-full md:w-auto"
        >
          {PRO014_WIZARD_TEXTS.CONTINUE}
          <ChevronRight className="ml-2 h-4 w-4" aria-hidden />
        </Button>
      </div>
    </div>
  );
}

export function Pro014EditStoresStep({
  campaignCode,
  onBack,
  onNext,
}: Pro014EditStoresStepProps): JSX.Element {
  return (
    <div className="space-y-4 animate-in fade-in duration-300">
      <Pro014StoresEditor
        campaignCode={campaignCode}
        renderFooter={(hasPendingChanges: boolean) => (
          <StepNavigation hasPendingChanges={hasPendingChanges} onBack={onBack} onNext={onNext} />
        )}
      />
    </div>
  );
}
